import { atom } from 'jotai';

/**
 * baseTimeZoneAtom
 * Maintains the base timezone for the current facility
 * The base atom is hydrated directly from the current facility and can be undefined.
 * Used by the ShutdownBanner to ensure the facility has a timezone set before making any changes to the shutdown.
 * If the current facility does not have a timezone an error is shown to the user.
 * see: @/components/shutdown-banner/shutdown-dialog.tsx
 *
 */
export const baseTimeZoneAtom = atom<string | undefined>(undefined);
baseTimeZoneAtom.debugLabel = 'baseTimeZoneAtom';

/**
 * timezoneAtom
 * Maintains the timezone for the current facility and defaults to UTC if undefined.
 * Used primarily with TZDate to ensure dates are in the facility's timezone for display and conversions.
 * see: @/features/reports/temperature-sheets/temperature-sheets.tsx
 */
export const timezoneAtom = atom<string>((get) => {
  const baseTimeZone = get(baseTimeZoneAtom);

  return baseTimeZone ?? 'UTC';
});
timezoneAtom.debugLabel = 'timezoneAtom';
